export default __webpack_public_path__ + "static/media/Events.056f74ef.png";